import { useEffect } from 'react';

import { Navigate } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { DEFAULT_SEGMENT } from '#client/build-env';
import { OrphanAccountRedirect } from '#client/components/OrphanAccountRedirect';
import { SHOW_ORPHAN_ACCOUNT_OPTIONS } from '#client/constants/experimentsFlags';
import * as ROUTES from '#client/constants/routes';

export default function Landing() {
  const { authenticated, accountUuid, login } = useAuthentication();
  const { loading: entityLoading, businessEntityUuid } = useBusinessEntity();
  const enableVeloRedirectOptions = useExperimentFlag(SHOW_ORPHAN_ACCOUNT_OPTIONS, false);

  useEffect(() => {
    if (!authenticated) {
      login(`${DEFAULT_SEGMENT}/`);
    }
  }, [authenticated, login]);

  if (!authenticated || entityLoading) {
    return <PageLoading />;
  }

  // Early return: edge case (token missing accountUuid)
  // Follows pattern from Authenticated.js - redirect to logout/accountNotFound
  if (!accountUuid) {
    return <Navigate to={`${ROUTES.logout}?redirectTo=${ROUTES.accountNotFound}`} replace />;
  }

  // User has valid auth + accountUuid + business entity → navigate to dashboard
  if (businessEntityUuid) {
    return <Navigate to={`${DEFAULT_SEGMENT}/${businessEntityUuid}/`} replace />;
  }

  // Orphan account: only reached when auth ready + entity loaded + no entity
  if (enableVeloRedirectOptions) {
    return <Navigate to={ROUTES.getStarted} replace />;
  }

  return <OrphanAccountRedirect />;
}
